<template>
<div>
  <div v-if="testappUse"><div :is="testappRoot"></div></div>
  <div class="cruise">
    <div class="uplinks" v-if="!route.meta.skipUplinks">
      <router-link  :to="{name: 'Search'}" :class="{act: active('river')}" >
      Речные круизы
      </router-link>

      <router-link :to="{name: 'SearchSea'}" :class="{act: active('sea')}" >
      Морские круизы
      </router-link>

      <router-link  :to="{name: 'ByHand'}" :class="{act: active('ByHand')}" >
      Конструктор
      </router-link>


    </div>
    <router-view />
  </div>
  <div class="versions">
    <a :href="gitlink" :title="gittitle" target="_blank">{{ver}}</a> <span :title="gate">gate</span>
  </div>
</div>
</template>

<style src="@/assets/styles/cruise-styles-main.scss" lang="scss"></style>

<style scoped lang="scss">
  .versions {
    text-align: right; 
    color:#999; font-size: 10px;
    a {
      color:#999; 
    }
  }
  .uplinks { 
    margin: 0 0 20px 0;
    background: #f0f0f0;
    box-shadow: 0px 10px 20px -10px rgba(0, 0, 0, 0.15);
    display: flex;

    a {
      height: 40px;
      display: flex;
      align-items: center;
      padding-left: 10px;
      padding-right: 10px;
      border-right: 1px solid rgba(155, 155, 155, 0.2);
      color: #0056bc;
      text-decoration: none;
      &.act { color: #3d3d3d; }
    }
  }
</style>

<script setup>
import {testappUse, testappRoutes, testappRoot   } from 'TESTAPP/testapp.js'
import { PLAY_SERENITI,extract_retlist_query } from '@/actions.js'
import { useRoute } from 'vue-router/composables'
import { computed } from 'vue'
import useCruiseStore from '@/cstore.js'
import 'TESTAPP/style.scss'

const cstore=useCruiseStore()
const route = useRoute()


const active = what => {
  let ret = false
  if ('ByHand'==what) {
    ret = what === route.name
  } else  {
    // Search SearchSea CruiseList Cruise 
    switch (route.name) {

      case 'Search': 
        ret = what === 'river'
      break;

      case 'SearchSea': 
        ret = what === 'sea'
      break;

      case 'CruiseList': 
        ret = what === route.query.type
      break;

      case 'Cruise':
        let {type} = extract_retlist_query( route.query.retlist )
        ret = what === type
      break;

      default: break;
    }
  }
  return ret
}

const list_link = computed( () => {
    let name = 'Search' // Search CruiseList
    let query = {}
    let text = 'Поиск круизов'
    let is = false
    if (cstore.crsearch_last.is) {
        name = 'CruiseList'
        query = cstore.crsearch_last.params
        text = 'Вернуться к поиску круизов'
        is = true
    } else if (route.query.retlist) {
        name = 'CruiseList'
        query = extract_retlist_query( route.query.retlist )
        text = 'Выполнить поиск круизов'
        is = true
    }
    return {text, to: {name, query}, is}
})


/*

{ force_prod: false, 
date: "Fri, 05 May 2023 09:22:30 GMT", 
commit: "b35a87532ec4c7aed30e8fa09457cbaca0f294f1", 
branch: "master" }

*/

const {date, commit, branch} = ETOBUILD
const gitlink = `https://git.eto.travel/amendelev/cruise/commits/branch/${branch}/search?q=${commit}`
const gittitle = `${date}; ${branch}`
const ver = commit.substr(0,7)
const gate = PLAY_SERENITI

</script>
